import React, { FC } from 'react'
import styled from 'styled-components'

import { circle, flexCenterChildren } from '@Globals/Style/mixins'

interface InfoIconProps {
  size?: string
}

const StyledInfoIcon = styled.div<{ size: string }>`
  ${flexCenterChildren}
  flex-shrink: 0;
  cursor: pointer;
  width: ${({ size }) => size};
  height: ${({ size }) => size};

  span {
    ${flexCenterChildren}
    width: ${({ size }) => size};
    height: ${({ size }) => size};
    line-height: 1;
    color: ${({ theme }) => theme.colors.white};
    font-family: Georgia, serif;
    font-size: calc(${({ size }) => size} * 0.75);
    background-color: ${({ theme }) => theme.colors.primary};
    ${({ size }) => circle(size)}
  }
`

export const InfoIcon: FC<InfoIconProps> = (
  {
    size = '30px',
  }: InfoIconProps,
) => (
  <StyledInfoIcon size={size}>
    <span>i</span>
  </StyledInfoIcon>
)
